import { useState } from "react";
import {
  Box,
  Button,
  IconButton,
  Stack,
  SvgIcon,
  Typography,
} from "@mui/material";
import { spamCheck } from "screens/Campaigns/CampaignService";
import ReplayIcon from "@mui/icons-material/Replay";
import CustomLoader from "global/components/CustomLoader/CustomLoader";
import { handleErrorMessage } from "helpers/methods";

interface CustomProps {
  exportPlainText: Function;
}

const SpamCheck = (props: CustomProps) => {
  const [spamWords, setSpamWords] = useState<string[]>([]);
  const [reRun, setReRun] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const runSpamCheck = async () => {
    try {
      setLoading(true);
      const content = await props.exportPlainText();
      const aiResponse = await spamCheck(content.text);
      setSpamWords(aiResponse.topSpamKeywords);
      setReRun(true);
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      handleErrorMessage(error);
    }
  };

  return (
    <Stack spacing={2}>
      <Stack spacing={1}>
        <Typography variant="h6">Spam Check</Typography>
        <Typography variant="body2">
          Spam Word Detection scans your email for terms flagged as spam.
          Removing them improves deliverability and avoids the spam folder.
        </Typography>
      </Stack>
      {reRun ? (
        Object.keys(spamWords).length > 0 ? (
          <Typography variant="body2">
            <Typography component="span" variant="body2" fontWeight="bold">
              Spam words detected:{" "}
            </Typography>
            {Object.keys(spamWords).join(", ")}
          </Typography>
        ) : (
          <Typography variant="body2">No spam words detected.</Typography>
        )
      ) : null}
      {reRun ? (
        <Box>
          <IconButton
            sx={{ border: "1px solid #7551D0" }}
            onClick={runSpamCheck}
          >
            <SvgIcon>
              <ReplayIcon htmlColor="#7551D0" />
            </SvgIcon>
          </IconButton>
        </Box>
      ) : (
        <Button variant="contained" size="small" onClick={runSpamCheck}>
          Run Spam Check
        </Button>
      )}
      <CustomLoader isLoading={loading} />
    </Stack>
  );
};

export default SpamCheck;
